import { useNavigate } from "react-router-dom";
import CloudStorage from "../../../CloudStorage/CloudStorage";

export default function ModelAcceptRejectPost({ setAcceptreject, posts, cancleit }) {
  const navigate = useNavigate();

  return (
    <div className="rent-product">
      <div className="modal-head">
        <h6>Cancel Request</h6>
        <button onClick={() => { navigate(-1) }} className="btn">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/x-circle.svg`}
            alt=""
          />
        </button>
      </div>

      <div className="filter-detail justify-contnt-between text-center">
        <p style={{ fontSize: "16px", margin: "20px 0" }}>
          Expert is requested for cancelling this post?
        </p>
      </div>

      <div className="submit-btn d-flex justify-content-center gap-3">
        <button
          type="button"
          className="btn btn-secondary"
          style={{ padding: '5px 100px', margin: '0px 20px' }}
          onClick={() => cancleit(2)}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary"
          style={{ backgroundColor: "#FF7A00", borderColor: "#FF7A00", padding: '5px 100px' }}
          onClick={() => cancleit(1)}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
